import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import { classNameWithModifiers as withMods } from 'helpers/class-name';

import Avatar from 'components/Avatar';
import './InstructorsListItem.scss';

const InstructorsListItem = ({
  id,
  firstName,
  lastName,
  pictureUrl,
  selectedItemId,
  selectInstructorId,
  shouldScrollToItem,
}) => {
  const fullName = `${firstName} ${lastName || ''}`;
  const isSelected = id === selectedItemId;
  const itemRef = useRef(null);
  useEffect(() => {
    if (isSelected && shouldScrollToItem) {
      itemRef.current.scrollIntoView();
    }
  });

  return (
    <li className={withMods('instructors-list-item', { isSelected })} ref={itemRef}>
      <button
        type="button"
        className="instructors-list-item__button"
        onClick={() => selectInstructorId({ instructorId: id, focus: 'details' })}
        data-cypress="instructors-list-item">
        <Avatar name={fullName} url={pictureUrl} className="ml-s mr-h" />
        {fullName}
      </button>
    </li>
  );
};

InstructorsListItem.propTypes = {
  id: PropTypes.number.isRequired,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
  pictureUrl: PropTypes.string,
  selectedItemId: PropTypes.number,
  selectInstructorId: PropTypes.func.isRequired,
  shouldScrollToItem: PropTypes.bool,
};

export default InstructorsListItem;
